/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

exports.onClientEntry = () => {
  // Take scroll handling into our own hands. With the browser's default
  // "auto" restoration, it re-applies the previous scroll position on
  // navigation - which fights our scroll-to-top and is why some pages didn't
  // land at the top. "manual" lets us decide (see onRouteUpdate below).
  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual"
  }
}

exports.shouldUpdateScroll = ({ routerProps: { location } }) => {
  // Hash anchors are handled in src/components/Layout.tsx via scrollToElement.
  // For everything else we reset scroll ourselves in onRouteUpdate, so tell
  // Gatsby not to manage (or restore) scroll here.
  return false
}

exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (typeof window === "undefined") return
  // Leave in-page hash anchors and the initial page load alone.
  if (location.hash) return
  if (!prevLocation || prevLocation.pathname === location.pathname) return

  // Jump to the very top of the new page. The explicit `behavior: "instant"`
  // bypasses the site-wide `scroll-behavior: smooth` (which otherwise turns
  // this into an animated scroll that doesn't reliably reach the top), and
  // requestAnimationFrame runs it after the new page has painted.
  window.requestAnimationFrame(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" })
  })
}
